import { render, staticRenderFns } from "./AnaliseAmbientalCard.vue?vue&type=template&id=82d689bc&scoped=true&"
import script from "./AnaliseAmbientalCard.vue?vue&type=script&lang=js&"
export * from "./AnaliseAmbientalCard.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseAmbientalCard.vue?vue&type=style&index=0&id=82d689bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d689bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VImg,VRow})
